var VODCurrentTime = function (episodeId) { return "vod-current-time-".concat(process.env.NODE_ENV, "-").concat(episodeId); };
export var getVodCurrentTime = function (episodeId) { return localStorage.getItem(VODCurrentTime(episodeId)); };
export var setVodCurrentTime = function (episodeId, value) { return localStorage.setItem(VODCurrentTime(episodeId), value); };
export var removeVodCurrentTime = function (episodeId) { return localStorage.removeItem(VODCurrentTime(episodeId)); };
export var getLocalStorageOffsetFieldName = function (postFix) {
    return "vod-offset-".concat(process.env.NODE_ENV, "-").concat(postFix);
};
